(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name adminCrewBatchers.controller:AdminCrewBatchersCtrl
   *
   * @description
   *
   */
  angular
    .module('adminCrewBatchers')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('AdminCrewBatchersCtrl', AdminCrewBatchersCtrl);

  function AdminCrewBatchersCtrl(EventManagerService,AdminCrewBatchService,MessageService,PopupManager,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'AdminCrewBatchersCtrl';
    
    vm.model = {
    	searchOnGoing : false,
    	searchPanelToggle:true,
    	initialSearchDone: false,
    	editorMode:applicationConstants.EDITOR_STATUS.ADD,
    	searchCriteria:{
             description:null,
             crewBatchCode : null,
             status : null
         },
         masterList:{
        	 statusList:[],
        	 isBatchCodeEditable:true
         },
         crewList:[],
         selectedCrewBatch:null,
         isElasticLoadingVisible:false
    };
    
    EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

    vm.clickOnSearch = function () {
        vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
        vm.model.initialSearchDone=false;
    };
	
    vm.searchByOptions = function(searchParams){
    	setDefault();
    	vm.searchCrewBatches();
    }
    
    vm.searchCrewBatches = function() {
      vm.model.crewList = [];
      vm.model.searchCriteria.startPosition = 1;
      vm.model.initialSearchDone = true;
      searchCrewBatch();
    };
    
    vm.selectBatch = function (selectedRowData) {
        vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
        vm.model.selectedCrewBatch = AdminCrewBatchService.formatGridRowData(selectedRowData);
        vm.model.masterList.isBatchCodeEditable = false;
    };
    
    vm.addNewCrewBatch = function () {
        vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
        vm.model.selectedCrewBatch = AdminCrewBatchService.getNewCrewBatch();
        vm.model.masterList.isBatchCodeEditable = true;
    };
    
    vm.submitCrewBatch = function(action, selectedItem) {
    	 vm.model.selectedCrewBatch = selectedItem;
         if (action === applicationConstants.EDITOR_STATUS.DELETE){
        	 deleteCrewBatch(selectedItem);
         }else{
        	 saveCrewBatch();
         }
	  };
        
    function searchCrewBatch() {
        showLoader(true);
        AdminCrewBatchService.setCrewBatchSearchCriteria(vm.model.searchCriteria);
        AdminCrewBatchService.getCrewBatches(
            function (batchList,startPosition) {
                updateCrewBatch(batchList);
                updateGridSearchStartPosition(startPosition);
                vm.model.searchPanelToggle = false;
                showLoader(false);
                vm.model.searchOnGoing = false;
            },
            function (error) {
                MessageService.error(error);
                showLoader(false);
            }
        );
    }
    
    function getNextSetOfRecords() {
        vm.model.isElasticLoadingVisible = true;
        if(!vm.model.searchOnGoing){
        	vm.model.searchOnGoing = true;
        	searchCrewBatch();
        }
    }
    
    function setDefault() {
    	vm.model.searchCriteria.pageSize = 100;
        vm.model.searchCriteria.startPosition = 1;
        vm.model.masterList.statusList = AdminCrewBatchService.searchStatusOptions();
        vm.addNewCrewBatch();
    }
    
    function updateCrewBatch(crewList) {
        angular.forEach(crewList, function (crew) {
            vm.model.crewList.push(crew);
        });
        vm.model.isElasticLoadingVisible = false;
    }
    
    function showLoader(flag) {
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
            flag: flag,
            target: 'adminCrewBatchers',
            animationName: 'crewing-loader'
        });
    }
    
    function updateGridSearchStartPosition(startPosition) {
    	 vm.model.searchCriteria.startPosition = startPosition;
    }
    
    
    function saveCrewBatch() {
    	AdminCrewBatchService.saveCrewBatch(vm.model.selectedCrewBatch,
            function (response) {
                if(response.success){
                    MessageService.success('Successfully saved the record!');
                    vm.searchCrewBatches();
                    vm.addNewCrewBatch();
                }else{
                    MessageService.error(response.errors[0]);
                }
            },
            function (error) {
                MessageService.error(error);
            }
        );
    }
    
    function deleteCrewBatch(selectedItem){
      var param = {
          title: 'Confirmation',
          messages: ["Do you want to delete this record"],
          flags: selectedItem
      };
      PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
    }
    
    
    function confirmDeleteDialog(pass) {
        if(pass==='YES'){
        	AdminCrewBatchService.deleteCrewBatch(vm.model.selectedCrewBatch,
                function (response) {
                    MessageService.success('Successfully deleted the record!');
                    vm.searchCrewBatches();
                    vm.addNewCrewBatch();
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }
    }
    
    setDefault();
    
  }
}());
